
import { Options, Vue } from "vue-class-component";

// plugins
import emailjs from "@emailjs/browser";
emailjs.init("user_tJQeT8oPh8t2hKaVxbHoR");

// firebase
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { setDoc, doc, addDoc, collection } from "firebase/firestore";
import { db } from "@/firebase";

@Options({})
export default class Card extends Vue {
  public showMessageWindow = false;
  public newMessage: any = "";
  public userId: any = String();
  public all_emails: any = []

  $props = {
    name: String,
    email: String,
    message: String
  }

  getUserData() {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        this.userId = user.uid;
      }
    });
  }

  sendEmail(email: any, name: any) {
    if (email != null && name != null && this.newMessage != "") {
      const templateParams: any = {
        email: email,
        name: name,
        message: this.newMessage,
      };
      emailjs.send("service_t64tqe6", "template_dfl0z3h", templateParams).then(
        function (response) {
          alert("Message sent successfully.");
          console.log(response);
        },
        function (error) {
          alert("Message sent successfully.");
          console.log(error);
        }
      );
      const emailData: any = {
        contact_name: name,
        email: email,
      };
      const messageData: any = {
        email: email,
        message: this.newMessage,
      };

      setDoc(doc(db, "partner_emails", this.userId, "chats", email), emailData);

      addDoc(
        collection(
          db,
          "partner_emails",
          this.userId,
          "chats",
          email,
          "messages"
        ),
        messageData
      );
    } else {
      alert("Form needs to be filled out before it can be sent.");
    }
  }
}
